/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { DialogService } from 'nebula-ui-kit';
import { lastValueFrom, map, Observable } from 'rxjs';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';
import { AsientoModal } from '../../domain/tipo-asiento-modal.model';
import { TipoAsientosService } from './tipo-asiento.service';

@Injectable({
  providedIn: 'root',
})
export class TipoAsientosModalService {
  readonly dialogService = inject(DialogService);
  readonly asientosService = inject(TipoAsientosService);

  openSelector(
    title: string,
    currentValue?: string,
    soloActivos = true,
  ): Observable<AsientoModal | null> {
    const columns = [
      {
        key: 'codigo',
        label: 'Código',
        sortable: true,
        width: '30%',
      },
      {
        key: 'nombre',
        label: 'Nombre',
        sortable: true,
        width: '50%',
      },
      {
        key: 'tipo',
        label: 'Tipo',
        sortable: true,
        width: '20%',
      },
    ];

    const loadDataFn = async (params: any): Promise<{ data: any[]; total: number }> => {
      try {
        const page = params.page - 1;
        const size = params.limit;
        const searchTerm = params.search || '';

        const response = await lastValueFrom(
          this.asientosService.getAsientosPaginados(page, size, searchTerm, soloActivos),
        );

        return {
          data: response.content,
          total: response.totalElements,
        };
      } catch (error) {
        console.error('Error al cargar tipos de asiento:', error);
        return { data: [], total: 0 };
      }
    };

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: columns,
        multiSelect: false,
        searchPlaceholder: 'Buscar por código o nombre...',
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        selectedItems: [],
        displayFn: (item: any) => {
          const codigo = item.codigo || '';
          const nombre = item.nombre || '';
          const nombreTruncado = this.truncateText(nombre, 30);
          return `${codigo} - ${nombreTruncado}`;
        },
      },
      size: 'lg',
      width: '800px',
    });

    return dialogRef.afterClosed().pipe(
      map((selected: AsientoModal[]) => {
        return selected && selected.length > 0 ? selected[0] : null;
      }),
    );
  }

  private truncateText(text: string, maxLength = 20): string {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}
